export const percentageOfNumber = (num, per) => Math.floor((num / per) * 100);
